import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ルート変更時にページトップにスクロールするコンポーネント
 * ハッシュ付きURL（#で始まる）の場合は、ハッシュ位置へのスクロールは各ページコンポーネントで処理される
 * useLayoutEffectを使用して、ブラウザが描画する前にスクロールを実行する
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // ハッシュがない場合のみ、ページトップにスクロール（描画前に実行）
    // ハッシュがある場合は、各ページコンポーネント（例: PostDetail）で処理される
    if (!hash) {
      window.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;

